import IcBaselineAccessTime from '~icons/ic/baseline-access-time'
import Countdown from 'src/components/Countdown'
import { cn } from 'src/utils/cx'
import type { CouponItem } from './states'

export function CouponCountDown(props: { coupon: CouponItem } & StyleProps) {
  return (
    props.coupon && (
      <div
        className={cn(
          'inline-flex items-center gap-0.5 bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300 px-1.5 py-0.5 text-xs rounded-full font-bold',
          props.className,
        )}
        style={props.style}
      >
        {/* Same icon as the one in the CreditPackCard */}
        <IcBaselineAccessTime className="size-3" />
        <Countdown
          targetDate={props.coupon.availableUntil}
          format="D:HH:mm:ss"
          className="tabular-nums"
        />
      </div>
    )
  )
}
